import {atom} from 'recoil';
import homeTypes from '../../types/home';

export const home = atom<homeTypes>({
  key: 'home',
  default: undefined,
});
